"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateInput_1 = require("../../../components/DateInput");

var Field_1 = require("../../Field");

exports.parse = function (value) {
  if (!value) {
    return null;
  }

  var year = ('000' + value.getFullYear()).slice(-4);
  var month = ('0' + (value.getMonth() + 1)).slice(-2);
  var day = ('0' + value.getDate()).slice(-2);
  return year + "-" + month + "-" + day;
};

exports.format = function (value) {
  if (!value) {
    return null;
  }

  var dateParts = value.split('-');

  try {
    var date = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[2], 10));
    return date && date.getTime() ? date : null;
  } catch (err) {
    return null;
  }
};

exports.DateField = Field_1.withField(DateInput_1.DatePickerInput, {
  parse: exports.parse,
  format: exports.format
});